import { createTheme } from "@mui/material/styles";
import { grey, red } from "@mui/material/colors";

// Create a theme instance.
const baseTheme = createTheme({
  palette: {
    primary: {
      main: "#FFFBF6",
    },
    accent: {
      main: "#8B5725",
    },
    secondary: {
      main: "#8B5725",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#fff",
    },
  },
  typography: {
    fontFamily: "Work Sans",
    h1: {
      fontSize: 32,
    },
    h2: {
      fontSize: 30,
    },
    h3: {
      fontSize: 28,
    },
    h4: {
      fontSize: 26,
    },
    h5: {
      fontSize: 24,
    },
    h6: {
      fontSize: 22,
    },
    subtitle1: {
      fontSize: 18,
    },
    body1: {
      fontSize: 16,
    },
    body2: {
      fontSize: 14,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 955, // modified this breakpoint value, default is 960
      lg: 1280,
      xl: 1920,
    },
  },
});

export default baseTheme;
